// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IApiStatus {
	version: string | undefined;

	versionDate: string | undefined;

	branch: string | undefined;

	lastCommitSHA: string | undefined;

	hasUncommittedChanges: boolean;

	inMaintenanceMode: boolean;

	startedAtUtc: string | undefined;

	machineName: string | undefined;

	workingSetBytes: number | undefined;

	$type?: string | undefined;
}
export class ApiStatus {
	constructor(data?: IApiStatus) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.versionDate) { this.versionDate = new Date(data.versionDate); }
		if (data.startedAtUtc) { this.startedAtUtc = new Date(data.startedAtUtc); }
	}

	version: string | undefined;

	versionDate: Date | undefined = new Date();

	branch: string | undefined;

	lastCommitSHA: string | undefined;

	hasUncommittedChanges: boolean = false;

	inMaintenanceMode: boolean = false;

	startedAtUtc: Date | undefined;

	machineName: string | undefined;

	workingSetBytes: number | undefined;

	static $type: string = "CoreApi.Models.ApiStatus, ";
	$type?: string | undefined = ApiStatus.$type;
}

